module.exports = __webpack_public_path__ + "img/gi.dce455a7.svg";